export default __webpack_public_path__ + "static/media/cuadro_retina_uno.8bf67113.png";